export default "__VITE_ASSET__3805780b__"